import React from "react";
import { Layout } from "../components/Layout";
import { useLanguage } from "../context/LanguageContext";
import { siteContent } from "../mock/rosablu.mock";
import { Card } from "../components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../components/ui/carousel";


export default function AboutPage() {
  const { lang } = useLanguage();
  const about = siteContent.about[lang];

  const images = [
    // Foto "Chi siamo" (famiglia)
    {
      src: "/images/rosablu/gallery/famiglia.jpeg",
      altIt: "Noi, la famiglia dietro Rosa Blu Apartment",
      altEn: "Us, the family behind Rosa Blu Apartment",
    },
    // Foto appartamento (ingresso, cucina, camera, bagno, esterni)
    {
      src: "/images/rosablu/gallery/cucina-vista.webp",
      altIt: "Vista dalla cucina verso la camera",
      altEn: "View from kitchen towards bedroom",
    },
    {
      src: "/images/rosablu/gallery/camera1.webp",
      altIt: "Camera con letto matrimoniale e singolo",
      altEn: "Bedroom with double and single bed",
    },
    {
      src: "/images/rosablu/gallery/camera2.webp",
      altIt: "Camera con letti e testata in legno",
      altEn: "Bedroom with beds and wooden headboard",
    },
    {
      src: "/images/rosablu/gallery/bagnob.webp",
      altIt: "Bagno con doccia in mosaico blu",
      altEn: "Bathroom with blue mosaic shower",
    },
    {
      src: "/images/rosablu/gallery/esterno.webp",
      altIt: "Esterno della casa e ingresso",
      altEn: "Exterior of the house and entrance",
    },
    // Foto Val di Sole / territorio
    {
      src: "/images/rosablu/gallery/valdisole-panorama.webp",
      altIt: "Panorama della Val di Sole",
      altEn: "Val di Sole landscape",
    },
    {
      src: "/images/rosablu/gallery/lago-alpino.webp",
      altIt: "Lago alpino in Val di Pejo",
      altEn: "Alpine lake in Val di Pejo",
    },
    {
      src: "/images/rosablu/gallery/montagne-neve.webp",
      altIt: "Pareti rocciose innevate in Val di Sole",
      altEn: "Snowy rocky peaks in Val di Sole",
    },
    {
      src: "/images/rosablu/gallery/commezzadura-estate.webp",
      altIt: "Commezzadura in estate",
      altEn: "Commezzadura in summer",
    },
    {
      src: "/images/rosablu/gallery/lago-valdisole.webp",
      altIt: "Lago alpino in Val di Sole",
      altEn: "Alpine lake in Val di Sole",
    },
    {
      src: "/images/rosablu/gallery/mestriago-inverno.webp",
      altIt: "Borgo di Mestriago in inverno",
      altEn: "Mestriago village in winter",
    },
  ];

  return (
    <Layout>
      <section className="bg-[#f8f1e8] pattern-about py-14 md:py-18">
        <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 md:flex-row md:gap-12 md:px-6">
          <div className="md:w-1/2">
            <h1 className="mb-4 font-serif text-2xl text-slate-900 md:text-3xl">
              {about.title}
            </h1>
            <p className="mb-3 text-sm leading-relaxed text-slate-700 md:text-base">
              {about.intro}
            </p>
            <p className="mb-3 text-sm leading-relaxed text-slate-700 md:text-base">
              {about.body}
            </p>
            <p className="mb-3 text-sm leading-relaxed text-slate-700 md:text-base">
              {about.body2}
            </p>
            <p className="mt-2 text-sm font-medium text-slate-800 md:text-base">
              {about.highlight}
            </p>
          </div>
          <div className="md:w-1/2">
            <Card className="h-full overflow-hidden rounded-3xl border-transparent bg-white/80 p-4 shadow-sm backdrop-blur-md">
              <Carousel className="w-full">
                <CarouselContent>
                  {images.map((img, index) => (
                    <CarouselItem key={index}>
                      <div className="overflow-hidden rounded-2xl">
                        <img loading="lazy"
                          src={img.src}
                          alt={lang === "it" ? img.altIt : img.altEn}
                          className="aspect-[4/3] w-full cursor-pointer object-cover transition-transform duration-500 hover:scale-105"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="left-2" />
                <CarouselNext className="right-2" />
              </Carousel>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
}
